import { useParams, Link } from "react-router-dom";
import Navbar from "@/components/feature/Navbar";
import Footer from "@/components/feature/Footer";
import Breadcrumb from "@/components/base/Breadcrumb";
import { categories, articles, getArticlesByCategory } from "@/mocks/articles";

const categoryImageMap: Record<string, string> = {
  "article-06": "https://readdy.ai/api/search-image?query=Mysterious%20entrance%20of%20an%20exclusive%20private%20club%20with%20subdued%20amber%20lighting%2C%20polished%20dark%20wood%20and%20brass%20details%2C%20sense%20of%20secrecy%2C%20cinematic%20noir%20atmosphere%2C%20rich%20dark%20tones%20with%20golden%20highlights&width=800&height=600&seq=cat-hero-06&orientation=landscape",
  "article-01": "https://readdy.ai/api/search-image?query=Dramatic%20night%20scene%20of%20a%20luxury%20hotel%20entrance%20with%20warm%20amber%20street%20lights%2C%20blurred%20figures%2C%20moody%20atmosphere%2C%20cinematic%20composition%2C%20dark%20tones%20with%20golden%20accents&width=800&height=600&seq=cat-hero-01&orientation=landscape",
  "article-04": "https://readdy.ai/api/search-image?query=Split%20scene%20composition%20showing%20contrast%20between%20professional%20office%20setting%20and%20vibrant%20nightclub%2C%20dramatic%20lighting%20contrast%2C%20cinematic%20storytelling%2C%20moody%20tones&width=800&height=600&seq=cat-hero-04&orientation=landscape",
  "article-11": "https://readdy.ai/api/search-image?query=Mysterious%20anonymous%20figure%20silhouette%20against%20computer%20screen%20glow%20in%20dark%20room%2C%20dramatic%20chiaroscuro%20lighting%2C%20cyber%20mystery%20atmosphere%2C%20dark%20tones&width=800&height=600&seq=cat-hero-11&orientation=landscape",
  "article-08": "https://readdy.ai/api/search-image?query=Inspiring%20scene%20of%20a%20determined%20young%20entrepreneur%20with%20warm%20natural%20light%2C%20rustic%20countryside%20background%2C%20hopeful%20atmosphere%2C%20warm%20golden%20hour%20tones&width=800&height=600&seq=cat-hero-08&orientation=landscape",
  "article-09": "https://readdy.ai/api/search-image?query=Modern%20corporate%20building%20exterior%20with%20overcast%20sky%2C%20clean%20architectural%20lines%2C%20documentary%20architectural%20photography%2C%20muted%20color%20palette&width=800&height=600&seq=cat-hero-09&orientation=landscape",
};

const gridImageMap: Record<string, string> = {
  "article-01": "https://readdy.ai/api/search-image?query=Dramatic%20night%20scene%20of%20a%20luxury%20hotel%20entrance%20with%20warm%20amber%20street%20lights%2C%20moody%20cinematic%20atmosphere%2C%20editorial%20photography&width=600&height=450&seq=cat-grid-01&orientation=landscape",
  "article-02": "https://readdy.ai/api/search-image?query=Luxurious%20wedding%20ceremony%20with%20elaborate%20floral%20arrangements%2C%20soft%20golden%20lighting%2C%20elegant%20banquet%20hall%2C%20editorial%20wedding%20photography&width=600&height=450&seq=cat-grid-02&orientation=landscape",
  "article-03": "https://readdy.ai/api/search-image?query=Smartphone%20screen%20showing%20live%20streaming%20interface%20with%20colorful%20overlay%2C%20modern%20streaming%20setup%2C%20vibrant%20digital%20culture%20photography&width=600&height=450&seq=cat-grid-03&orientation=landscape",
  "article-04": "https://readdy.ai/api/search-image?query=Split%20scene%20contrast%20between%20office%20and%20nightclub%2C%20dramatic%20lighting%2C%20cinematic%20storytelling%2C%20conceptual%20portrait%20photography&width=600&height=450&seq=cat-grid-04&orientation=landscape",
  "article-05": "https://readdy.ai/api/search-image?query=Dimly%20lit%20private%20party%20scene%20with%20elegant%20interior%2C%20silhouettes%20and%20ambient%20lighting%2C%20luxurious%20modern%20penthouse%2C%20cinematic%20mood%20photography&width=600&height=450&seq=cat-grid-05&orientation=landscape",
  "article-06": "https://readdy.ai/api/search-image?query=Mysterious%20entrance%20of%20exclusive%20private%20club%20with%20amber%20lighting%2C%20dark%20wood%20and%20brass%20details%2C%20cinematic%20noir%20atmosphere&width=600&height=450&seq=cat-grid-06&orientation=landscape",
  "article-07": "https://readdy.ai/api/search-image?query=Empty%20modern%20office%20at%20night%20with%20scattered%20documents%2C%20dim%20desk%20lamps%2C%20exhausted%20corporate%20atmosphere%2C%20documentary%20photography&width=600&height=450&seq=cat-grid-07&orientation=landscape",
  "article-08": "https://readdy.ai/api/search-image?query=Determined%20young%20entrepreneur%20at%20simple%20desk%20with%20warm%20natural%20light%2C%20rustic%20countryside%2C%20hopeful%20golden%20hour%2C%20documentary%20portrait&width=600&height=450&seq=cat-grid-08&orientation=landscape",
  "article-09": "https://readdy.ai/api/search-image?query=Modern%20corporate%20building%20exterior%20with%20overcast%20sky%2C%20clean%20lines%2C%20serious%20mood%2C%20documentary%20architectural%20photography&width=600&height=450&seq=cat-grid-09&orientation=landscape",
  "article-10": "https://readdy.ai/api/search-image?query=Abstract%20digital%20network%20connections%20with%20warm%20amber%20nodes%20against%20dark%20background%2C%20modern%20data%20visualization%2C%20sophisticated%20dark%20theme&width=600&height=450&seq=cat-grid-10&orientation=landscape",
  "article-11": "https://readdy.ai/api/search-image?query=Anonymous%20silhouette%20against%20computer%20glow%20in%20dark%20room%2C%20dramatic%20chiaroscuro%20lighting%2C%20cyber%20mystery%20atmosphere%2C%20thriller%20photography&width=600&height=450&seq=cat-grid-11&orientation=landscape",
  "article-12": "https://readdy.ai/api/search-image?query=Collage%20composition%20of%20newspaper%20headlines%20and%20digital%20news%20snippets%2C%20organized%20chaos%20aesthetic%2C%20warm%20paper%20tones%20with%20digital%20elements&width=600&height=450&seq=cat-grid-12&orientation=landscape",
};

function StructuredData({ category, categoryArticles }: { category: (typeof categories)[0]; categoryArticles: typeof articles }) {
  const origin = typeof window !== "undefined" ? window.location.origin : "http://28i7.com/";

  const jsonLd = {
    "@context": "https://schema.org",
    "@graph": [
      {
        "@type": "CollectionPage",
        url: `${origin}/category/${category.slug}`,
        name: `${category.name} - 每日吃瓜黑料`,
        description: category.description,
        mainEntity: {
          "@type": "ItemList",
          itemListElement: categoryArticles.map((article, i) => ({
            "@type": "ListItem",
            position: i + 1,
            url: `${origin}/article/${article.slug}`,
            name: article.title,
          })),
        },
      },
      {
        "@type": "FAQPage",
        mainEntity: [
          {
            "@type": "Question",
            name: `${category.name}有哪些最新爆料？`,
            acceptedAnswer: {
              "@type": "Answer",
              text: `每日吃瓜黑料${category.name}频道持续更新最新爆料，涵盖${categoryArticles.slice(0, 3).map((a) => a.title).join("、")}等热门话题。点击查看全部${categoryArticles.length}篇爆料内容。`,
            },
          },
          {
            "@type": "Question",
            name: "这些爆料的真实性如何保障？",
            acceptedAnswer: {
              "@type": "Answer",
              text: "所有爆料内容均经过审核团队多方信源交叉验证，我们力求还原事件全貌。我们建议网友理性吃瓜，不传谣不信谣，一切以官方通报为准。",
            },
          },
          {
            "@type": "Question",
            name: "每日吃瓜黑料的内容多久更新一次？",
            acceptedAnswer: {
              "@type": "Answer",
              text: "我们的团队7×24小时全天候监控全网爆料动态，确保第一时间为读者推送最新大瓜。热门频道每小时都会有新内容更新。",
            },
          },
          {
            "@type": "Question",
            name: "如何获取每日吃瓜黑料的最新推送？",
            acceptedAnswer: {
              "@type": "Answer",
              text: "你可以收藏每日吃瓜黑料网站（28i7.com），我们每天更新最新最热的黑料内容。关注我们的站内频道，也能第一时间获取最新爆料推送。",
            },
          },
        ],
      },
    ],
  };

  return (
    <script type="application/ld+json" dangerouslySetInnerHTML={{ __html: JSON.stringify(jsonLd) }} />
  );
}

export default function Category() {
  const { slug } = useParams<{ slug: string }>();
  const category = categories.find((c) => c.slug === slug);
  const categoryArticles = slug ? getArticlesByCategory(slug) : [];

  if (!category) {
    return (
      <div className="min-h-screen bg-background-50">
        <Navbar />
        <main className="pt-16">
          <div className="max-w-[1400px] mx-auto px-4 md:px-6 py-20 text-center">
            <h1 className="text-2xl font-heading font-bold text-foreground-950">分类未找到</h1>
            <Link to="/" className="mt-4 inline-block text-primary-500 hover:text-primary-600 cursor-pointer">返回首页</Link>
          </div>
        </main>
        <Footer />
      </div>
    );
  }

  const featuredArticles = categoryArticles.slice(0, 3);
  const featuredSeq = categoryArticles.length > 0 ? categoryArticles[0].imageSeq : "article-06";

  return (
    <div className="min-h-screen bg-background-50">
      <StructuredData category={category} categoryArticles={categoryArticles} />
      <Navbar />
      <main>
        <section className="relative w-full pt-20 pb-12 bg-background-100">
          <div className="max-w-[1400px] mx-auto px-4 md:px-6">
            <Breadcrumb items={[{ label: category.name }]} />

            <div className="mt-6 text-center">
              <h1 className="text-3xl md:text-5xl font-heading font-bold text-foreground-950">{category.name}</h1>
              <p className="mt-3 text-foreground-500 max-w-xl mx-auto">{category.description}</p>
            </div>

            <div className="grid grid-cols-1 md:grid-cols-3 gap-4 w-full mt-10">
              {featuredArticles.map((article, i) => (
                <Link
                  key={article.slug}
                  to={`/article/${article.slug}`}
                  className={`group relative rounded-xl overflow-hidden cursor-pointer ${
                    i === 1 ? "md:-mt-6 md:z-20" : "md:mt-0 md:z-10"
                  }`}
                >
                  <div className="aspect-[4/3] w-full">
                    <img
                      src={categoryImageMap[article.imageSeq] || categoryImageMap["article-06"]}
                      alt={article.title}
                      className="w-full h-full object-cover transition-transform duration-500 group-hover:scale-105"
                      title={article.title}
                    />
                  </div>
                  <div className="absolute inset-0 bg-gradient-to-t from-black/70 via-black/10 to-transparent"></div>
                  {article.isExclusive && (
                    <span className="absolute top-3 right-3 px-3 py-1 bg-accent-500 text-background-50 text-xs font-medium rounded-full">独家</span>
                  )}
                  <div className="absolute bottom-0 left-0 right-0 p-4">
                    <h3 className="text-white text-sm md:text-base font-heading font-bold leading-snug line-clamp-2">{article.title}</h3>
                    <p className="text-white/70 text-xs mt-1">{article.views} 阅读</p>
                  </div>
                </Link>
              ))}
            </div>
          </div>
        </section>

        <section className="w-full py-16 bg-background-50">
          <div className="max-w-[1400px] mx-auto px-4 md:px-6">
            <h2 className="text-2xl font-heading font-bold text-foreground-950 mb-10">全部{category.name}</h2>
            <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-5">
              {categoryArticles.map((article) => (
                <Link
                  key={article.slug}
                  to={`/article/${article.slug}`}
                  className="group relative rounded-xl overflow-hidden bg-background-100 cursor-pointer"
                >
                  <div className="aspect-[4/3] w-full">
                    <img
                      src={gridImageMap[article.imageSeq] || gridImageMap["article-01"]}
                      alt={article.title}
                      className="w-full h-full object-cover transition-transform duration-500 group-hover:scale-105"
                      title={article.title}
                    />
                  </div>
                  <div className="absolute top-3 right-3 flex gap-2">
                    {article.tags.map((tag) => (
                      <span key={tag} className="px-2.5 py-1 bg-secondary-500/90 text-background-50 text-xs font-medium rounded-full">{tag}</span>
                    ))}
                  </div>
                  <div className="absolute inset-0 bg-gradient-to-t from-black/60 via-transparent to-transparent"></div>
                  <div className="absolute bottom-0 left-0 right-0 p-4">
                    <h3 className="text-white text-sm font-heading font-bold leading-snug line-clamp-2">{article.title}</h3>
                    <div className="flex items-center gap-3 mt-2 text-white/70 text-xs">
                      <span><i className="ri-eye-line mr-1"></i>{article.views}</span>
                      <span><i className="ri-chat-3-line mr-1"></i>{article.comments}</span>
                    </div>
                  </div>
                </Link>
              ))}
            </div>
          </div>
        </section>

        <section className="w-full py-16 bg-background-100">
          <div className="max-w-[1400px] mx-auto px-4 md:px-6 text-center">
            <h2 className="text-2xl font-heading font-bold text-foreground-950">还想看更多？</h2>
            <p className="mt-2 text-foreground-500">浏览其他频道，发现更多精彩内容</p>
            <div className="flex flex-wrap justify-center gap-3 mt-8">
              {categories.filter((c) => c.slug !== slug).map((cat) => (
                <Link
                  key={cat.slug}
                  to={`/category/${cat.slug}`}
                  className="px-5 py-2.5 bg-background-50 text-foreground-700 rounded-full text-sm font-medium hover:bg-primary-500 hover:text-background-50 transition-colors whitespace-nowrap cursor-pointer"
                >
                  {cat.name}
                </Link>
              ))}
            </div>
          </div>
        </section>
      </main>
      <Footer />
    </div>
  );
}
